export default "__VITE_ASSET__DpQD5ZCw__"